/**
 * @generated SignedSource<<eb107138fb3eb150006e5d51a6412c21>>
 * @relayHash c940743bfdac1210674c6a2f97ff96c1
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c940743bfdac1210674c6a2f97ff96c1

import { ConcreteRequest } from 'relay-runtime';
export type Ch_rejectPatientAsPotentialDuplicateInput = {
  patientId: string;
};
export type chRejectPatientAsPotentialDuplicateMutation$variables = {
  input: Ch_rejectPatientAsPotentialDuplicateInput;
};
export type chRejectPatientAsPotentialDuplicateMutation$data = {
  readonly rejectPatientAsPotentialDuplicate: {
    readonly boolean: boolean | null;
    readonly errors: ReadonlyArray<{
      readonly message?: string;
    }> | null;
  };
};
export type chRejectPatientAsPotentialDuplicateMutation = {
  response: chRejectPatientAsPotentialDuplicateMutation$data;
  variables: chRejectPatientAsPotentialDuplicateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "boolean",
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "Error",
  "abstractKey": "__isError"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "chRejectPatientAsPotentialDuplicateMutation",
    "selections": [
      {
        "alias": "rejectPatientAsPotentialDuplicate",
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_rejectPatientAsPotentialDuplicatePayload",
        "kind": "LinkedField",
        "name": "ch_rejectPatientAsPotentialDuplicate",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "chRejectPatientAsPotentialDuplicateMutation",
    "selections": [
      {
        "alias": "rejectPatientAsPotentialDuplicate",
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_rejectPatientAsPotentialDuplicatePayload",
        "kind": "LinkedField",
        "name": "ch_rejectPatientAsPotentialDuplicate",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "c940743bfdac1210674c6a2f97ff96c1",
    "metadata": {},
    "name": "chRejectPatientAsPotentialDuplicateMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "48ef00677256624ce064c420f8253f26";

export default node;
